import React, { useState, useEffect, useCallback } from "react";
import {
  MdLogout,
  MdAdd,
  MdBarcodeReader,
  MdLockOpen,
  MdLock,
  MdDeleteOutline,
  MdArrowRight,
  MdUpload,
  MdListAlt,
  MdErrorOutline,
  MdPeople,
} from "react-icons/md";
import { FaNewspaper } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import "react-toastify/dist/ReactToastify.css";
import "../../../components/css/Dashboard.css";
import ModalTurno from "../../../components/modals/ModalTurno";
import ModalTurnoDetalle from "../../../components/modals/ModalTurnoDetalle";
import ModalCargaMasivaTurnoDetalle from "../../../components/modals/ModalCargaMasivaTurnoDetalle";
import ModalErroresCargaMasivaTurno from "../../../components/modals/ModalErroresCargaMasivaTurno";
import ModalDetalleConsumosProveedor from "../../../components/modals/ModalDetalleConsumosProveedor";
import ModalCompletarDetalleTurno from "../../../components/modals/ModalCompletarDetalleTurno";
import { useComedores } from '../../../services/hooks/useComedores';
// import { useClientes } from '../../../services/hooks/useClientes'; // No se necesita cargar clientes al inicio
import { useTurnos } from '../../../services/hooks/useTurnos';
import { useLectores } from '../../../services/hooks/useLectores';
import { useTipoEntradas } from '../../../services/hooks/useTipoEntradas';

const GestionarTurnos = () => {
  const navigate = useNavigate();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem("token");
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

  // Usar los custom hooks
  const { comedores, fetchComedoresByProyecto } = useComedores();
  // const { clientes, fetchAllClientesByUser } = useClientes(); // No se necesita cargar clientes al inicio
  const { turnos, fetchTurnosByProyecto, fetchTurnosTotal, createTurnoCabecera, updateTurnoCabecera, deleteTurnoTotal } = useTurnos();
  const { fetchLectoresByProyecto } = useLectores();
  const { tipoEntradas, fetchTipoEntradas } = useTipoEntradas();

  // Variables de estado
  const [isNewModalOpen, setIsNewModalOpen] = useState(false);
  const [isModalTurnoDetalleOpen, setIsModalTurnoDetalleOpen] = useState(false);  
  const [isModalCargaMasivaOpen, setIsModalCargaMasivaOpen] = useState(false);
  const [isModalErroresCargaOpen, setIsModalErroresCargaOpen] = useState(false);
  const [isModalDetalleConsumosOpen, setIsModalDetalleConsumosOpen] = useState(false);
  const [isModalCompletarDetalleOpen, setIsModalCompletarDetalleOpen] = useState(false);
  const [tipoServicio, setTipoServicio] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [turnoToDelete, setTurnoToDelete] = useState(null);
  const [showOpenModal, setShowOpenModal] = useState(false);
  const [turnoToOpen, setTurnoToOpen] = useState(null);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [turnoToClose, setTurnoToClose] = useState(null);

  const showToast = (type, message) => {
    if (type === "success") {
      toast.success(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "error") {
      toast.error(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "info") {
      toast.info(message, { position: "bottom-right", autoClose: 3000 });
    } else if (type === "warning") {
      toast.warning(message, { position: "bottom-right", autoClose: 3000 });
    }
  };
  
  // Redirect if not authenticated
  useEffect(() => {
    if (!token || !currentUser) {
      navigate("/");
    }
  }, [navigate, token, currentUser]);

  // Fetch data para cargar turnos al inicio
  useEffect(() => {
    if (selectedProject && selectedProject.id && currentUser?.id) {
      fetchTurnosByProyecto(selectedProject.id);
      // Los clientes se cargarán solo cuando se abra un modal que los requiera
    }
  }, [selectedProject?.id, currentUser?.id, fetchTurnosByProyecto]);

  // Cargar datos básicos específicos por modal (optimizado para evitar cargas innecesarias)
  useEffect(() => {
    const loadModalData = async () => {
      if (!currentUser?.id || !selectedProject?.id) {
        return;
      }

      try {
        if (isNewModalOpen) {
          // Solo cargar datos necesarios para el modal de nuevo turno
          console.log('Cargando datos para ModalTurno...');
          await Promise.all([
            fetchComedoresByProyecto(selectedProject.id),
            fetchLectoresByProyecto(selectedProject.id)
          ]);
        } else if (isModalTurnoDetalleOpen) {
          // ModalTurnoDetalle no necesita cargar datos adicionales
          // Los comedores ya están disponibles desde la carga inicial
          console.log('ModalTurnoDetalle abierto - usando datos ya cargados');
        }
      } catch (error) {
        console.error("Error al cargar los datos del modal:", error);
        showToast("error", "Error al cargar los datos del modal");
      }
    };

    loadModalData();
  }, [isNewModalOpen, isModalTurnoDetalleOpen, currentUser?.id, selectedProject?.id, fetchComedoresByProyecto, fetchLectoresByProyecto]);

  const fetchDataForTurnoModal = useCallback(async () => {
    try {
      const tipos = await fetchTipoEntradas();
      setTipoServicio(tipos); // Ajusta según lo que devuelva tu hook
    } catch (error) {
      console.error("Error al cargar tipos de entrada:", error);
      showToast("error", "Error al cargar tipos de entrada");
    }
  }, [fetchTipoEntradas, showToast]);

  // Cargar tipos de entrada solo al abrir ModalTurno
  useEffect(() => {
    if (isNewModalOpen) {
      fetchDataForTurnoModal();
    }
  }, [isNewModalOpen]); // Eliminada dependencia fetchDataForTurnoModal para evitar bucle infinito

  useEffect(() => {
    if (isModalTurnoDetalleOpen && !turnoSeleccionado) {
      console.log("Cerrando ModalTurnoDetalle porque no hay turno seleccionado");
      setIsModalTurnoDetalleOpen(false);
    }
  }, [isModalTurnoDetalleOpen, turnoSeleccionado]);

  // Handle row selection
  const handleRowClick = (turno) => {
    setTurnoSeleccionado(turno);
  };

  // Close ModalTurno and possibly reload data
  const handleCloseModalTurno = (hasNewTurnTotal = false) => {
    setIsNewModalOpen(false);
    if (hasNewTurnTotal && selectedProject?.id) {
      fetchTurnosByProyecto(selectedProject.id);
    }
  };

  // Close ModalTurnoDetalle and reload the page
  const handleCloseModalTurnoDetalle = (isReloadPage = false) => {
    setIsModalTurnoDetalleOpen(false);
    if (isReloadPage) {
      fetchTurnosByProyecto(selectedProject.id);
      setTurnoSeleccionado(null);
    }
  };

  const handleCloseModalCompletarDetalle = (isReloadPage = false) => {
    setIsModalCompletarDetalleOpen(false);
    if (isReloadPage && selectedProject?.id) {
      fetchTurnosByProyecto(selectedProject.id);
      setTurnoSeleccionado(null);
    }
  };

  // Close ModalCargaMasiva and reload the page
  const handleCloseModalCargaMasiva = (isReloadPage = false) => {
    setIsModalCargaMasivaOpen(false);
    if (isReloadPage) {
      fetchTurnosByProyecto(selectedProject.id);
      setTurnoSeleccionado(null);
    }
  };

  const abrirTurno = () => {
    if (!turnoSeleccionado) {
      showToast("error", "Debe seleccionar un turno para abrirlo");
      return;
    }
    if (turnoSeleccionado.cerrado == 0 || turnoSeleccionado.cerrado === "0") {
      showToast("success", "Turno ya abierto");
      return;
    }

    setTurnoToOpen(turnoSeleccionado);
    setShowOpenModal(true);
  };

  const confirmOpenTurno = async () => {
    if (!turnoToOpen) return;

    setShowOpenModal(false);
    
    try {
      await updateTurnoCabecera(turnoToOpen.id, { cerrado: 0 });
      setTurnoSeleccionado(null);
      setTurnoToOpen(null);
      fetchTurnosByProyecto(selectedProject.id);
      showToast("success", "Turno abierto con éxito");
    } catch (error) {
      showToast("error", "Error al abrir el turno: " + error.message);
      setTurnoToOpen(null);
    }
  };

  const cancelOpenTurno = () => {
    setShowOpenModal(false);
    setTurnoToOpen(null);
  };

  const cerrarTurno = () => {
    if (!turnoSeleccionado) {
      showToast("error", "Debe seleccionar un turno para cerrarlo");
      return;
    }
    if (turnoSeleccionado.cerrado == 1 || turnoSeleccionado.cerrado === "1") {
      showToast("success", "Turno ya cerrado");
      return;
    }

    setTurnoToClose(turnoSeleccionado);
    setShowCloseModal(true);
  };

  const confirmCloseTurno = async () => {
    if (!turnoToClose) return;

    setShowCloseModal(false);
    
    try {
      await updateTurnoCabecera(turnoToClose.id, { cerrado: 1 });
      setTurnoSeleccionado(null);
      setTurnoToClose(null);
      fetchTurnosByProyecto(selectedProject.id);
      showToast("success", "Turno cerrado con éxito");
    } catch (error) {
      showToast("error", "Error al cerrar el turno: " + error.message);
      setTurnoToClose(null);
    }
  };

  const cancelCloseTurno = () => {
    setShowCloseModal(false);
    setTurnoToClose(null);
  };

  const eliminarTurno = () => {
    if (!turnoSeleccionado) {
      showToast("error", "Debe seleccionar un turno para eliminarlo");
      return;
    }

    setTurnoToDelete(turnoSeleccionado);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!turnoToDelete) return;

    setShowDeleteModal(false);
    
    try {
      await deleteTurnoTotal(turnoToDelete.id);
      setTurnoSeleccionado(null);
      setTurnoToDelete(null);
      fetchTurnosByProyecto(selectedProject.id);
      showToast("success", "Turno eliminado con éxito");
    } catch (error) {
      console.error("Error al eliminar turno:", error);
      
      // Manejar específicamente el error de turno con detalles
      if (error.response && error.response.status === 422 && error.response.data?.error === 'TURNO_CON_DETALLES') {
        showToast("error", error.response.data.message);
      } else if (error.response && error.response.data?.message) {
        showToast("error", error.response.data.message);
      } else {
        showToast("error", "Error al eliminar el turno: " + (error.message || error));
      }
      
      setTurnoToDelete(null);
    }
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setTurnoToDelete(null);
  };
    
  return (
    <div className="container-fluid py-4">
      {/* Paleta Digital Harmony - Estilos Directos */}
      <style>
        {`
          
          /* Aplicar paleta a botones - COLORES ABSOLUTOS */
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(17, 153, 142, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.5);
            color: white;
          }
          
          .btn-dh-success {
            background: linear-gradient(135deg, #ff8c00 0%, #ff6b00 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(255, 140, 0, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-success:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(255, 140, 0, 0.5);
            color: white;
          }
          
          .btn-dh-info {
            background: linear-gradient(135deg, #00c6ff 0%, #0072ff 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(6, 182, 212, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-info:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(6, 182, 212, 0.5);
            color: white;
          }
          
          .btn-dh-warning {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(245, 158, 11, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-warning:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(245, 158, 11, 0.5);
            color: white;
          }
          
          .btn-dh-danger {
            background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(239, 68, 68, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-danger:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(239, 68, 68, 0.5);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #374151 100%);
            border: none;
            color: white;
            box-shadow: 0 4px 14px 0 rgba(107, 114, 128, 0.39);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.5);
            color: white;
          }
          
          /* Botón Ingresos cuando no hay selección */
          .btn-outline-secondary {
            background: linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%) !important;
            border: 2px solid #9ca3af !important;
            color: #6b7280 !important;
            box-shadow: 0 2px 8px 0 rgba(156, 163, 175, 0.2) !important;
            transition: all 0.3s ease !important;
          }
          
          .btn-outline-secondary:hover {
            background: linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%) !important;
            border-color: #6b7280 !important;
            color: #374151 !important;
            transform: translateY(-1px) !important;
            box-shadow: 0 4px 12px rgba(156, 163, 175, 0.3) !important;
          }
          
          /* Estilo para card header */
          .card-header-dh {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 0.5rem 0.5rem 0 0;
          }
          
          .card-header-dh h5 {
            color: white;
            font-weight: 600;
          }
          
          /* Enhanced Table - Tabla Moderna - TÍTULOS VISIBLES */
          .table-dh {
            border-collapse: separate;
            border-spacing: 0;
            background: white;
            border-radius: 0.75rem;
            overflow: hidden;
            box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
          }
          
          .table-dh thead {
            background: #374151 !important;
            border-bottom: 3px solid #4f46e5 !important;
          }
          
          .table-dh thead th {
            color: white !important;
            font-weight: 700 !important;
            font-size: 0.875rem !important;
            letter-spacing: 0.025em !important;
            text-transform: uppercase !important;
            border: none !important;
            padding: 1.25rem 1rem !important;
            position: relative !important;
            background: none !important;
          }
          
          .table-dh thead th::after {
            content: '';
            position: absolute;
            right: 0;
            top: 25%;
            height: 50%;
            width: 1px;
            background: rgba(255, 255, 255, 0.2);
          }
          
          .table-dh thead th:last-child::after {
            display: none;
          }
          
          .table-dh tbody tr {
            transition: all 0.2s ease-in-out;
            border-bottom: 1px solid #f3f4f6;
          }
          
          .table-dh tbody tr:hover {
            background: linear-gradient(135deg, #f9fafb 0%, rgba(79, 70, 229, 0.02) 100%);
            transform: translateY(-1px);
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          }
          
          .table-dh tbody tr.table-primary {
            background: linear-gradient(135deg, rgba(79, 70, 229, 0.1) 0%, rgba(129, 140, 248, 0.1) 100%);
            border-left: 4px solid #4f46e5;
            box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.1), 0 2px 4px -1px rgba(79, 70, 229, 0.06);
          }
          
          .table-dh tbody tr:last-child {
            border-bottom: none;
          }
          
          .table-dh tbody td {
            padding: 1.25rem 1rem;
            vertical-align: middle;
            border: none;
            font-size: 0.9rem;
            line-height: 1.5;
          }
          
          /* Iconos para headers - VISIBLES */
          .header-icon {
            display: inline-flex !important;
            align-items: center !important;
            gap: 0.5rem !important;
            color: white !important;
          }
          
          .header-icon i {
            color: #818cf8 !important;
            font-size: 1rem !important;
          }
          
          .table-dh thead th .header-icon {
            color: white !important;
          }
          
          /* Forzar visibilidad de texto en headers */
          .table-dh thead tr th,
          .table-dh thead tr th span,
          .table-dh thead tr th .header-icon {
            color: white !important;
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          /* Card moderno */
          .card-dh {
            border: none;
            border-radius: 1rem;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          }
          
          .card-dh .card-body {
            padding: 1.5rem;
          }
          
          /* Estados de turno */
          .estado-abierto {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            color: white;
            padding: 0.25rem 0.75rem;
            border-radius: 1rem;
            font-size: 0.875rem;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
          }
          
          .estado-cerrado {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
            color: white;
            padding: 0.25rem 0.75rem;
            border-radius: 1rem;
            font-size: 0.875rem;
            font-weight: 500;
            box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3);
          }
          
          /* Cantidad de comensales */
          .cantidad-comensales {
            background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
            color: #1e1b4b;
            padding: 0.25rem 0.75rem;
            border-radius: 1rem;
            font-size: 0.875rem;
            font-weight: 700;
            min-width: 40px;
            text-align: center;
            display: inline-block;
            border: 2px solid #4f46e5;
            box-shadow: 0 2px 8px rgba(79, 70, 229, 0.2);
          }

          .consumos-sincronizados {
            background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
            color: #065f46;
            padding: 0.25rem 0.75rem;
            border-radius: 1rem;
            font-size: 0.875rem;
            font-weight: 700;
            min-width: 40px;
            text-align: center;
            display: inline-block;
            border: 2px solid #059669;
            box-shadow: 0 2px 8px rgba(5, 150, 105, 0.2);
          }
          
          /* Checkbox personalizado */
          .form-check-input:checked {
            background-color: #4f46e5;
            border-color: #4f46e5;
          }
          
          .form-check-input:focus {
            box-shadow: 0 0 0 0.25rem rgba(79, 70, 229, 0.25);
          }
          
          /* Elementos de tabla limpios */
          .comedor-name {
            font-weight: 600;
            color: #111827;
            font-size: 1rem;
          }
          
          .table-dh tbody td span {
            color: #374151;
            font-weight: 500;
          }
          
          /* Empty state mejorado */
          .empty-state {
            background: linear-gradient(135deg, var(--dh-gray-50) 0%, var(--dh-gray-100) 100%);
            border: 2px dashed var(--dh-gray-300);
            border-radius: 0.75rem;
            padding: 3rem 2rem;
            text-align: center;
          }
          
          .empty-state-icon {
            font-size: 3rem;
            color: var(--dh-gray-400);
            margin-bottom: 1rem;
          }
          
          .empty-state-text {
            color: var(--dh-gray-600);
            font-size: 1.1rem;
            font-weight: 500;
            margin-bottom: 0.5rem;
          }
          
          .empty-state-subtext {
            color: var(--dh-gray-500);
            font-size: 0.9rem;
          }
          
          /* Loading skeleton */
          .loading-skeleton {
            background: linear-gradient(90deg, var(--dh-gray-200) 25%, var(--dh-gray-100) 50%, var(--dh-gray-200) 75%);
            background-size: 200% 100%;
            animation: loading 1.5s infinite;
            border-radius: 0.5rem;
          }
          
          @keyframes loading {
            0% { background-position: 200% 0; }
            100% { background-position: -200% 0; }
          }
          
          .skeleton-row {
            padding: 1.25rem 1rem;
          }
          
          .skeleton-item {
            height: 20px;
            margin-bottom: 0.5rem;
          }
          
          .skeleton-item:last-child {
            margin-bottom: 0;
          }
          
          /* Micro-animations */
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .table-dh tbody tr {
            animation: fadeInUp 0.3s ease-out;
          }
          
          .table-dh tbody tr:nth-child(1) { animation-delay: 0.05s; }
          .table-dh tbody tr:nth-child(2) { animation-delay: 0.1s; }
          .table-dh tbody tr:nth-child(3) { animation-delay: 0.15s; }
          .table-dh tbody tr:nth-child(4) { animation-delay: 0.2s; }
          .table-dh tbody tr:nth-child(5) { animation-delay: 0.25s; }
        `}
      </style>
      <ToastContainer />
      <div className="card card-dh">
        <div className="card-header card-header-dh py-3">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Gestionar Turnos</h5>
            <div className="btn-group">
              <button
                onClick={() => setIsNewModalOpen(true)}
                className="btn btn-dh-primary d-flex align-items-center gap-2"
              >
                <FaNewspaper size={20} />
                <MdAdd size={20} />
                Nuevo Turno
              </button>
              <button
                className={`btn d-flex align-items-center gap-2 ${
                  turnoSeleccionado && 
                  (turnoSeleccionado.cerrado == 0 || turnoSeleccionado.cerrado === "0") &&
                  turnoSeleccionado.tipo_servicio_alimentacion?.id
                    ? 'btn-dh-info' 
                    : 'btn-outline-secondary'
                }`}
                onClick={() => {
                  if (!turnoSeleccionado) {
                    showToast("error", "Por favor seleccione un turno para poder ingresar comensales");
                    return;
                  }
                  
                  // Validar si el turno está cerrado
                  if (turnoSeleccionado.cerrado == 1 || turnoSeleccionado.cerrado === "1") {
                    showToast("error", `No se pueden registrar ingresos en un turno cerrado. El turno del comedor "${turnoSeleccionado.comedor?.nombre}" debe estar abierto para permitir el registro de comensales.`);
                    return;
                  }
                  
                  // Validar que el turno tenga un tipo de servicio de alimentación asignado
                  if (!turnoSeleccionado.tipo_servicio_alimentacion?.id) {
                    showToast("error", `El turno del comedor "${turnoSeleccionado.comedor?.nombre}" no tiene un tipo de servicio de alimentación asignado. Por favor, asigne un tipo de servicio antes de registrar comensales.`);
                    return;
                  }
                  
                  setIsModalTurnoDetalleOpen(true);
                }}
                title={
                  !turnoSeleccionado 
                    ? "Seleccione un turno primero"
                    : (turnoSeleccionado.cerrado == 1 || turnoSeleccionado.cerrado === "1")
                      ? "No se pueden registrar ingresos en un turno cerrado"
                      : !turnoSeleccionado.tipo_servicio_alimentacion?.id
                        ? "El turno no tiene un tipo de servicio de alimentación asignado"
                        : "Ingresar comensales al turno seleccionado"
                }
              >
                <MdBarcodeReader size={20} />
                Ingresos
              </button>
              <button
                className={`btn d-flex align-items-center gap-2 ${
                  turnoSeleccionado ? 'btn-dh-info' : 'btn-outline-secondary'
                }`}
                onClick={() => {
                  if (!turnoSeleccionado) {
                    showToast("error", "Por favor seleccione un turno para completar el detalle");
                    return;
                  }
                  if (turnoSeleccionado.cerrado == 1 || turnoSeleccionado.cerrado === "1") {
                    showToast(
                      "error",
                      `No se puede completar detalle en un turno cerrado. El turno del comedor "${turnoSeleccionado.comedor?.nombre}" debe estar abierto.`
                    );
                    return;
                  }
                  setIsModalCompletarDetalleOpen(true);
                }}
                title={
                  !turnoSeleccionado
                    ? "Seleccione un turno primero"
                    : (turnoSeleccionado.cerrado == 1 || turnoSeleccionado.cerrado === "1")
                      ? "No se puede completar detalle en un turno cerrado"
                      : "Ajustar cantidad de comensales con el turno del día anterior"
                }
              >
                <MdPeople size={20} />
                Completar detalle
              </button>
              <button
                className={`btn d-flex align-items-center gap-2 ${
                  turnoSeleccionado ? 'btn-dh-info' : 'btn-outline-secondary'
                }`}
                onClick={() => {
                  setIsModalCargaMasivaOpen(true);
                }}
                title="Carga masiva de turno detalle desde Excel (automático o con turno seleccionado)"
              >
                <MdUpload size={20} />
                Carga Masiva
              </button>
              <button
                className={`btn d-flex align-items-center gap-2 ${
                  turnoSeleccionado ? 'btn-dh-info' : 'btn-outline-secondary'
                }`}
                onClick={() => {
                  if (!turnoSeleccionado) {
                    showToast("error", "Por favor seleccione un turno para ver el detalle de consumos");
                    return;
                  }
                  setIsModalDetalleConsumosOpen(true);
                }}
                title={
                  turnoSeleccionado
                    ? "Ver detalle de consumos y enviar al proveedor externo"
                    : "Seleccione un turno primero"
                }
              >
                <MdListAlt size={20} />
                Detalle
              </button>
              <button
                className={`btn d-flex align-items-center gap-2 ${
                  turnoSeleccionado && (turnoSeleccionado.errores_carga_masiva ?? 0) > 0
                    ? 'btn-dh-warning'
                    : 'btn-outline-secondary'
                }`}
                onClick={() => {
                  if (!turnoSeleccionado) {
                    showToast("error", "Por favor seleccione un turno para ver los errores de carga");
                    return;
                  }
                  if ((turnoSeleccionado.errores_carga_masiva ?? 0) === 0) {
                    showToast("info", "Este turno no tiene errores pendientes de regularización");
                    return;
                  }
                  navigate("/procesos/alimentacion/errores-carga-masiva", {
                    state: { idTurnoCabecera: turnoSeleccionado.id },
                  });
                }}
                title={
                  turnoSeleccionado && (turnoSeleccionado.errores_carga_masiva ?? 0) > 0
                    ? `Ver ${turnoSeleccionado.errores_carga_masiva} error(es) de carga masiva`
                    : "Seleccione un turno con errores de carga masiva"
                }
              >
                <MdErrorOutline size={20} />
                Ver errores
                {turnoSeleccionado && (turnoSeleccionado.errores_carga_masiva ?? 0) > 0 ? (
                  <span className="badge bg-danger ms-1">{turnoSeleccionado.errores_carga_masiva}</span>
                ) : null}
              </button>
              <button 
                className="btn btn-dh-success d-flex align-items-center gap-2" 
                onClick={() => abrirTurno()}
              >
                <MdLockOpen size={20} />
                Abrir
              </button>
              <button 
                className="btn btn-dh-warning d-flex align-items-center gap-2" 
                onClick={() => cerrarTurno()}
              >
                <MdLock size={20} />
                Cerrar
              </button>
              <button 
                className="btn btn-dh-danger d-flex align-items-center gap-2" 
                onClick={() => eliminarTurno()}
              >
                <MdDeleteOutline size={20} />
                Eliminar
              </button>
              <button 
                className="btn btn-dh-secondary d-flex align-items-center gap-2" 
                onClick={() => navigate("/home")}
              >
                <MdLogout size={20} />
                Cerrar
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover table-dh">
              <thead>
                <tr>
                  <th style={{ width: "60px", textAlign: "center" }}>
                    <span className="header-icon">
                      <MdArrowRight />
                    </span>
                  </th>                  
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-store"></i>
                      Comedor
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-utensils"></i>
                      Tipo Servicio
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-barcode"></i>
                      Lectora
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-calendar-alt"></i>
                      Fecha
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-users"></i>
                      Cantidad
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <MdErrorOutline />
                      Errores
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-cloud-upload-alt"></i>
                      Sincronizados
                    </span>
                  </th>
                  <th>
                    <span className="header-icon">
                      <i className="fas fa-toggle-on"></i>
                      Estado
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {turnos && turnos.length > 0 ? (
                  turnos.map((turno) => (
                    <tr 
                      key={turno.id} 
                      className={turnoSeleccionado?.id === turno.id ? 'selectedTr table-primary' : ''}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleRowClick(turno)}
                    >
                      <td style={{ textAlign: "center" }}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`checkTurno${turno.id}`}
                            checked={turnoSeleccionado?.id === turno.id}
                            onChange={() => handleRowClick(turno)}
                          />
                          <label className="form-check-label" htmlFor={`checkTurno${turno.id}`}>
                            <MdArrowRight size={16} />
                          </label>
                        </div>
                      </td>                     
                      <td>
                        <div className="comedor-name">
                          {turno.comedor?.nombre || "-"}
                        </div>
                      </td>
                      <td>
                        <span>
                          {turno.tipo_servicio_alimentacion?.descripcion || "-"}
                        </span>
                      </td>
                      <td>
                        <span>
                          {turno.lectora?.nombre || "-"}
                        </span>
                      </td>
                      <td>
                        <span>
                          {turno.fecha_turno && (() => {
                            // Evitar problemas de zona horaria parseando manualmente
                            const [year, month, day] = turno.fecha_turno.split('T')[0].split('-');
                            return `${day}/${month}/${year}`;
                          })()}
                        </span>
                      </td>
                      <td>
                        <span className="cantidad-comensales">
                          {turno.cantidad_comensales}
                        </span>
                      </td>
                      <td>
                        <span
                          className={turno.errores_carga_masiva > 0 ? "text-danger fw-bold" : ""}
                          title="Errores pendientes de regularización (carga masiva incompleta)"
                          style={{ cursor: turno.errores_carga_masiva > 0 ? "pointer" : "default" }}
                          onClick={(e) => {
                            if (turno.errores_carga_masiva > 0) {
                              e.stopPropagation();
                              navigate("/procesos/alimentacion/errores-carga-masiva", {
                                state: { idTurnoCabecera: turno.id },
                              });
                            }
                          }}
                        >
                          {turno.errores_carga_masiva ?? 0}
                        </span>
                      </td>
                      <td>
                        <span
                          className="consumos-sincronizados"
                          title="Consumos enviados exitosamente al proveedor externo"
                        >
                          {turno.consumos_enviados_proveedor ?? 0}
                        </span>
                      </td>
                      <td>
                        <span className={turno.cerrado == 0 || turno.cerrado === "0" ? "estado-abierto" : "estado-cerrado"}>
                          {turno.cerrado == 0 || turno.cerrado === "0" ? "Abierto" : "Cerrado"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="p-0">
                      <div className="empty-state">
                        <div className="empty-state-icon">
                          <i className="fas fa-calendar-times"></i>
                        </div>
                        <div className="empty-state-text">
                          No tiene turnos creados
                        </div>
                        <div className="empty-state-subtext">
                          Haga clic en "Nuevo Turno" para crear su primer turno
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <ModalTurno
        proyecto={selectedProject}
        comedores={comedores}
        tipoEntrada={tipoEntradas}
        isOpen={isNewModalOpen}
        onClose={handleCloseModalTurno}
      />
      {isModalTurnoDetalleOpen && turnoSeleccionado ? (
        <ModalTurnoDetalle
          tipoServicio={tipoServicio}
          turnoSeleccionado={turnoSeleccionado}
          comedores={comedores}
          isOpen={isModalTurnoDetalleOpen}
          onClose={handleCloseModalTurnoDetalle}
          showToast={showToast}
        />
      ) : null}

      {isModalCargaMasivaOpen ? (
        <ModalCargaMasivaTurnoDetalle
          turnoSeleccionado={turnoSeleccionado}
          isOpen={isModalCargaMasivaOpen}
          onClose={handleCloseModalCargaMasiva}
          showToast={showToast}
        />
      ) : null}

      {isModalCompletarDetalleOpen && turnoSeleccionado ? (
        <ModalCompletarDetalleTurno
          turnoSeleccionado={turnoSeleccionado}
          isOpen={isModalCompletarDetalleOpen}
          onClose={handleCloseModalCompletarDetalle}
          showToast={showToast}
        />
      ) : null}

      {isModalErroresCargaOpen && turnoSeleccionado ? (
        <ModalErroresCargaMasivaTurno
          turnoSeleccionado={turnoSeleccionado}
          isOpen={isModalErroresCargaOpen}
          onClose={() => setIsModalErroresCargaOpen(false)}
          showToast={showToast}
        />
      ) : null}

      {isModalDetalleConsumosOpen && turnoSeleccionado ? (
        <ModalDetalleConsumosProveedor
          turnoSeleccionado={turnoSeleccionado}
          isOpen={isModalDetalleConsumosOpen}
          onClose={() => {
            setIsModalDetalleConsumosOpen(false);
            if (selectedProject?.id) {
              fetchTurnosByProyecto(selectedProject.id);
            }
          }}
          showToast={showToast}
        />
      ) : null}

      {/* Modal de confirmación de eliminación */}
      <Modal
        title={
          <span style={{ color: '#dc2626', fontWeight: '600' }}>
            <MdDeleteOutline size={20} className="me-2" />
            Confirmar Eliminación de Turno
          </span>
        }
        open={showDeleteModal}
        onOk={confirmDelete}
        onCancel={cancelDelete}
        okText="Sí, Eliminar Turno"
        cancelText="Cancelar"
        okType="danger"
        centered
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600',
            color: 'white'
          }
        }}
        cancelButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #6b7280 0%, #374151 100%)',
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
      >
        <div style={{ padding: '1rem 0' }}>
          {turnoToDelete && turnoToDelete.cantidad_comensales > 0 && (
            <div style={{
              background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
              border: '2px solid #fca5a5',
              padding: '1rem',
              borderRadius: '12px',
              marginBottom: '1.5rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem'
            }}>
              <div style={{
                background: '#dc2626',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <span style={{ color: 'white', fontSize: '20px' }}>⚠️</span>
              </div>
              <div>
                <p style={{ 
                  color: '#dc2626', 
                  marginBottom: '0.5rem', 
                  fontSize: '1rem', 
                  fontWeight: '700' 
                }}>
                  ⚠️ ADVERTENCIA: Turno con Comensales Asociados
                </p>
                <p style={{ 
                  color: '#991b1b', 
                  marginBottom: '0', 
                  fontSize: '0.9rem' 
                }}>
                  Este turno tiene <strong>{turnoToDelete.cantidad_comensales} comensal(es)</strong> registrado(s). 
                  Al eliminar el turno, también se eliminarán todos los registros de comensales asociados.
                </p>
              </div>
            </div>
          )}
          
          <p style={{ color: '#374151', marginBottom: '1.5rem', fontSize: '1.1rem', fontWeight: '600' }}>
            ¿Está seguro de que desea eliminar este turno?
          </p>
          
          {turnoToDelete && (
            <div style={{ 
              background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
              border: '1px solid #e2e8f0',
              padding: '1.25rem',
              borderRadius: '12px',
              marginBottom: '1.5rem'
            }}>
              <h4 style={{ 
                color: '#1e293b', 
                marginBottom: '1rem', 
                fontSize: '1rem',
                fontWeight: '700',
                borderBottom: '2px solid #e2e8f0',
                paddingBottom: '0.5rem'
              }}>
                📋 Datos del Turno
              </h4>
              
              <div style={{ display: 'grid', gap: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontWeight: '600' }}>Comedor:</span>
                  <span style={{ color: '#1e293b', fontWeight: '500' }}>
                    {turnoToDelete.comedor?.nombre || 'N/A'}
                  </span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontWeight: '600' }}>Tipo de Servicio:</span>
                  <span style={{ color: '#1e293b', fontWeight: '500' }}>
                    {turnoToDelete.tipo_servicio_alimentacion?.descripcion || 'N/A'}
                  </span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontWeight: '600' }}>Lectora:</span>
                  <span style={{ color: '#1e293b', fontWeight: '500' }}>
                    {turnoToDelete.lectora?.nombre || 'N/A'}
                  </span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontWeight: '600' }}>Fecha:</span>
                  <span style={{ color: '#1e293b', fontWeight: '500' }}>
                    {turnoToDelete.fecha_turno ? (() => {
                      const [year, month, day] = turnoToDelete.fecha_turno.split('T')[0].split('-');
                      return `${day}/${month}/${year}`;
                    })() : 'N/A'}
                  </span>
                </div>
                
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  padding: '0.5rem',
                  borderRadius: '6px',
                  background: turnoToDelete.cantidad_comensales > 0 ? '#fef2f2' : '#f0f9ff',
                  border: turnoToDelete.cantidad_comensales > 0 ? '1px solid #fecaca' : '1px solid #bae6fd'
                }}>
                  <span style={{ 
                    color: turnoToDelete.cantidad_comensales > 0 ? '#dc2626' : '#0369a1', 
                    fontWeight: '600' 
                  }}>
                    Cantidad de Comensales:
                  </span>
                  <span style={{ 
                    color: turnoToDelete.cantidad_comensales > 0 ? '#dc2626' : '#0369a1', 
                    fontWeight: '700',
                    fontSize: '1.1rem'
                  }}>
                    {turnoToDelete.cantidad_comensales || 0}
                  </span>
                </div>
                
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#64748b', fontWeight: '600' }}>Estado:</span>
                  <span style={{ 
                    color: turnoToDelete.cerrado == 0 || turnoToDelete.cerrado === "0" ? '#059669' : '#dc2626',
                    fontWeight: '600',
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    background: turnoToDelete.cerrado == 0 || turnoToDelete.cerrado === "0" ? '#d1fae5' : '#fee2e2'
                  }}>
                    {turnoToDelete.cerrado == 0 || turnoToDelete.cerrado === "0" ? 'Abierto' : 'Cerrado'}
                  </span>
                </div>
              </div>
            </div>
          )}
          
          <div style={{
            background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
            border: '1px solid #f59e0b',
            padding: '1rem',
            borderRadius: '8px'
          }}>
            <p style={{ 
              color: '#92400e', 
              marginBottom: '0', 
              fontSize: '0.9rem', 
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              <span>⚠️</span>
              <span>Esta acción no se puede deshacer. Se eliminará permanentemente el turno y todos sus registros asociados.</span>
            </p>
          </div>
        </div>
      </Modal>

      {/* Modal de confirmación para abrir turno */}
      <Modal
        title={
          <span style={{ color: '#11998e', fontWeight: '600' }}>
            <MdLockOpen size={20} className="me-2" />
            Confirmar Apertura de Turno
          </span>
        }
        open={showOpenModal}
        onOk={confirmOpenTurno}
        onCancel={cancelOpenTurno}
        okText="Abrir Turno"
        cancelText="Cancelar"
        centered
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
        cancelButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #6b7280 0%, #374151 100%)',
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
      >
        <div style={{ padding: '1rem 0' }}>
          <p style={{ color: '#374151', marginBottom: '1rem', fontSize: '1.1rem' }}>
            ¿Está seguro de que desea abrir este turno?
          </p>
          {turnoToOpen && (
            <div style={{ 
              background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1rem'
            }}>
              <p style={{ color: '#374151', marginBottom: '0.5rem', fontWeight: '600' }}>
                <strong>Comedor:</strong> {turnoToOpen.comedor?.nombre || 'N/A'}
              </p>
              <p style={{ color: '#374151', marginBottom: '0.5rem' }}>
                <strong>Tipo de Servicio:</strong> {turnoToOpen.tipo_servicio_alimentacion?.descripcion || 'N/A'}
              </p>
              <p style={{ color: '#374151', marginBottom: '0' }}>
                <strong>Estado actual:</strong> <span style={{ color: '#f59e0b', fontWeight: '600' }}>Cerrado</span>
              </p>
            </div>
          )}
          <p style={{ color: '#6b7280', marginBottom: '0', fontSize: '0.9rem' }}>
            Esta acción cambiará el estado del turno a "Abierto" y permitirá el registro de comensales.
          </p>
        </div>
      </Modal>

      {/* Modal de confirmación para cerrar turno */}
      <Modal
        title={
          <span style={{ color: '#f59e0b', fontWeight: '600' }}>
            <MdLock size={20} className="me-2" />
            Confirmar Cierre de Turno
          </span>
        }
        open={showCloseModal}
        onOk={confirmCloseTurno}
        onCancel={cancelCloseTurno}
        okText="Cerrar Turno"
        cancelText="Cancelar"
        centered
        okButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            border: 'none',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
        cancelButtonProps={{
          style: {
            background: 'linear-gradient(135deg, #6b7280 0%, #374151 100%)',
            border: 'none',
            color: 'white',
            borderRadius: '8px',
            fontWeight: '600'
          }
        }}
      >
        <div style={{ padding: '1rem 0' }}>
          <p style={{ color: '#374151', marginBottom: '1rem', fontSize: '1.1rem' }}>
            ¿Está seguro de que desea cerrar este turno?
          </p>
          {turnoToClose && (
            <div style={{ 
              background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
              padding: '1rem',
              borderRadius: '8px',
              marginBottom: '1rem'
            }}>
              <p style={{ color: '#374151', marginBottom: '0.5rem', fontWeight: '600' }}>
                <strong>Comedor:</strong> {turnoToClose.comedor?.nombre || 'N/A'}
              </p>
              <p style={{ color: '#374151', marginBottom: '0.5rem' }}>
                <strong>Tipo de Servicio:</strong> {turnoToClose.tipo_servicio_alimentacion?.descripcion || 'N/A'}
              </p>
              <p style={{ color: '#374151', marginBottom: '0' }}>
                <strong>Estado actual:</strong> <span style={{ color: '#11998e', fontWeight: '600' }}>Abierto</span>
              </p>
            </div>
          )}
          <p style={{ color: '#6b7280', marginBottom: '0', fontSize: '0.9rem' }}>
            Esta acción cambiará el estado del turno a "Cerrado" y no permitirá más registros de comensales.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default GestionarTurnos